module.exports = __webpack_public_path__ + "assets/media/prix_in.7f6b449c.jpg";